import { render } from "./ExamQuestion.vue?vue&type=template&id=2ca21b88"
import script from "./ExamQuestion.vue?vue&type=script&lang=js"
export * from "./ExamQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__